import React from 'react';
import { FormProps } from 'util/Form';
import DateFormItem from 'components/shared/DateFormItem';

interface DateQuestionFormItemProps extends FormProps {
  fieldName: string;
  required?: boolean;
  validationRule?: string;
  validationErrorMessage?: string;
}

const DateQuestionFormItem: React.FunctionComponent<DateQuestionFormItemProps> = ({
  fieldName,
  required,
  disabled,
  validationRule,
  validationErrorMessage,
}) => {
  return (
    <DateFormItem
      fieldName={fieldName}
      required={required}
      disabled={disabled}
      validationRule={validationRule}
      validationErrorMessage={validationErrorMessage}
    />
  );
};
export default DateQuestionFormItem;
